import { Grid, IconButton, Tooltip } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DeleteIcon from '@mui/icons-material/Delete';
import { AttachmentActionsProps } from './props';
import { downloadFile } from '../../../../../../shared/utils/files';
import { useAttachmentActions } from './hook';

export const AttachmentActions = ({
    attachment,
    onDelete,
}: AttachmentActionsProps) => {
    const { handleDelete } = useAttachmentActions(onDelete);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Descargar">
                <IconButton
                    size="small"
                    onClick={() =>
                        attachment.url &&
                        downloadFile(attachment.url, attachment.name)
                    }
                >
                    <CloudDownloadIcon color="warning" />
                </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar">
                <IconButton
                    size="small"
                    onClick={() => handleDelete(attachment.id || '')}
                >
                    <DeleteIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
